import { render, staticRenderFns } from "./profit_return_detail.vue?vue&type=template&id=49e76ad5&scoped=true"
import script from "./profit_return_detail.vue?vue&type=script&lang=js"
export * from "./profit_return_detail.vue?vue&type=script&lang=js"
import style0 from "./profit_return_detail.vue?vue&type=style&index=0&id=49e76ad5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e76ad5",
  null
  
)

export default component.exports